<template>
  <!--
          作者：yel
          时间：2021-3-18
          描述：表单模板
      -->
  <div class="product">
    <!--搜索-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="渠道名称">
          <el-input size="small" v-model="searchForm.company_name" placeholder="请输入渠道名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--添加-->
    <div class="common-level-rail">
      <!-- v-auth="'/plus/xxx/xxx'" -->
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus" >添加</el-button>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table  size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          
          <el-table-column prop="distributor_id" label="ID" width="100"></el-table-column>
          <el-table-column prop="name" label="渠道名称"></el-table-column>
          <el-table-column prop="mobile" label="联系方式"></el-table-column>
          <el-table-column prop="user_id" label="绑定用户" width="300">
            <template slot-scope="scope" v-if="scope.row.user">
              <div class="d-s-c">
                <img :src="scope.row.user.avatarUrl" width="60px" height="60px" />
                <div class="ml10">
                  <p class="f14 fb">{{ scope.row.user.nickName }}</p>
                  <p class="gray3" v-if="scope.row.user.mobile">手机：{{ scope.row.user.mobile }}</p>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="status_text" label="状态"></el-table-column>
          <el-table-column prop="create_time" label="创建时间"></el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button @click="openQrcode('qrcode', scope.row)" type="text" size="small">查看二维码</el-button>
              <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/distributor/distributor/edit'">编辑</el-button>
              <el-button @click="delClick(scope.row)" type="text" size="small" v-auth="'/distributor/distributor/del'">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>


    <!--弹窗引入-->
    <Op v-if="open_add" :open_add="open_add" :addform="Oneform" @closeDialog="closeDialogFunc($event)"></Op>
    <!--页面链接-->
    <Qrcode v-if="show_qrcode" :is_open="show_qrcode" :dataModel="dataModel" @closeDialog="closeDialogFunc($event, 'qrcode')"></Qrcode>

  </div>
</template>

<script>
  import DistributorApi from '@/api/distributor.js';
  import Op from './dialog/Op.vue';
  import Qrcode from '@/components/image/qrcode';

  export default {
    components: {
      Op,
      Qrcode
    },
    data() {
      return {
        show_qrcode:false,
        //加载
        loading: true,// true 为加载中   false 加载结束
        //搜索控制
        searchForm: {
          company_name: ''  //标题
        },

        //表格数据
        tableData: [],/*列表数据*/
        totalDataNumber: 0,/*总条数*/
        pageSize: 20,/*一页多少条*/
        curPage: 1,/*当前是第几页*/


        /*是否打开添加弹窗*/
        open_add: false,
        /*选择的当前行对象数据*/
        Oneform:{
          type:'add',
          model:{}
        },

      };
    },
    created() {
      /*获取列表*/
      this.getData();
    },
    methods: {
       // 选项卡 start
       handleClick(tab, event) {
         /*切换选项卡 */
         let self = this;
         self.curPage = 1; //变为第一页
         self.loading = true;//加载中
         self.getData(); //获取数据
       },
       // 选项卡 end


       /*搜索查询*/
       onSubmit() {
         let self = this;
         self.loading = true;//加载中
         self.getData();//获取数据
       },

      //列表数据 start

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val; //选择的页数
        self.loading = true; //加载中
        self.getData();//获取数据
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;  //调到第一页
        this.pageSize = val; //每页多少条
        this.getData(); //获取数据
      },

      /*获取列表*/
      getData() {
        let self = this;
        let Params = {};
        Params = self.searchForm; //搜索
        Params.page = self.curPage; //当前页数
        Params.list_rows = self.pageSize;//每页多少条

        //请求接口
        DistributorApi.getList(Params, true).then(res => {
          console.log(8888)
          self.loading = false;//加载结束
          self.tableData = res.data.list.data; //把数据给列表
          self.totalDataNumber = res.data.list.total;//一共多少条

        }).catch(error => {
          self.loading = false; //加载结束
        });
      },

      //列表数据 end

      //操作 start

      /*删除*/
      delClick: function(row) {
        let self = this;
        // self.loading = true;
        self.$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
          type: 'warning'
        }).then(() => {

          //请求接口
          DistributorApi.del({
            distributor_id: row.distributor_id
          }).then(data => {
            self.$message({
              message: '删除成功',
              type: 'success'
            });
            self.getData();
          });

        });
      },

      //操作 end
      /*打开添加*/
      addClick() {
        this.Oneform.model = {};
        this.Oneform.type = 'add';
        this.open_add = true;
      },
      //编辑
      editClick($row){
        console.log($row)
        this.Oneform.model = $row;
        this.Oneform.type = 'edit';
        this.open_add = true;
      },
      //详情
      dateilClick($row){
        this.Oneform.model = $row;
        this.Oneform.type = 'dateil';
        this.open_add = true;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        this.open_add = e.openDialog;
        this.show_qrcode = e.openDialog;
        console.log(e)
        if (e.type == 'success') {
          this.getData();
        }
      },
      /*打开弹窗*/
      openQrcode(name, item){
        this.dataModel = item;
        this.show_qrcode = true;
      },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/distributor/distributor/index.vue